<template>
  <b-tabs
    pills
    fill
  >
    <b-tab active>
      <template #title>
        <feather-icon icon="TruckIcon" />
        <span>Servis Bilgileri</span>
      </template>
      <validation-observer ref="simpleRules">
        <item-form />
        <save-button
          :save-action="submitForm"
          :is-disabled="submitStatus"
        />
      </validation-observer>
    </b-tab>
    <b-tab lazy>
      <template #title>
        <FeatherIcon icon="UsersIcon" />
        <span>Müşteri Bilgileri</span>
      </template>
      <customer-card />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ItemForm from '@/views/Services/ItemForm.vue'
import CustomerCard from '@/views/Services/CustomerCard.vue'

export default {
  name: 'Add',
  components: {
    BTabs,
    BTab,
    ItemForm,
    CustomerCard,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
    saveData() {
      return this.$store.getters['services/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/services/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  created() {
    localize('tr')
    this.$store.dispatch('services/resetDataItem')
  },
  mounted() {
    this.dataItem.id_customers = this.$route.params.id
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.dataItem.submitStatus = true
          this.$store.dispatch('services/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
